import { computed } from "mobx";
import { useMemo } from "react";
import { usePipedriveStore } from "..";
import LocalStorageService from "../services/localStorageService";

const useCurrentOrFallbackPipedriveUserId = (): number => {
    const localStorage = useMemo(() => new LocalStorageService(), []);
    const pipedriveStore = usePipedriveStore();

    return useMemo(() => computed(() => localStorage.getPipedriveUserId() || pipedriveStore.users[0]?.id), []).get();
}

export default useCurrentOrFallbackPipedriveUserId;